module.exports = __webpack_public_path__ + "img/login-ad.b7432b6e.png";